import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ControlValueAccessor } from '@angular/forms';
import { ValuePair } from 'app/shared/interfaces/ValuePair';

@Component({
  selector: 'ls-form-multi-checkbox',
  templateUrl: 'ls-form-multi-checkbox.component.html'
})
export class LsFormMultiCheckboxComponent
  implements OnInit, ControlValueAccessor {
  @Input()
  public description: string;
  @Input()
  public disabled: boolean;
  @Input()
  public key: string;
  @Input()
  public title: string;
  @Input()
  public options: Array<ValuePair>;
  @Input()
  public value: Array<string>;
  @Input()
  public form: FormGroup;
  @Input()
  public visible = true;

  public displayTitle: string;

  public ngOnInit(): void {
    this.displayTitle = this.title;
  }

  public writeValue(value: any): void {
    this.value = value;
  }

  public registerOnChange(): void {
    return;
  }

  public registerOnTouched(): void {
    return;
  }

  public selectionChanged(status: {
    totalOptions: Number;
    totalSelected: Number;
  }): void {
    this.displayTitle = `${this.title} (${status.totalSelected}/${
      status.totalOptions
    })`;
  }
}
